import { useEffect, useState } from "react";

// Offline / slow-network awareness for the donation flow (2026-10-06). The
// server-side scheduler already copes with the PHONE dropping off; this is
// about the participant's BROWSER: show what is happening instead of a bare
// error, and let polling resume when the connection returns.
export const useNetworkStatus = () => {
    const nav = typeof navigator !== "undefined" ? navigator : {};
    const conn = () => nav.connection || nav.mozConnection || nav.webkitConnection || null;
    const read = () => ({
        online: typeof nav.onLine === "boolean" ? nav.onLine : true,
        effectiveType: conn() ? conn().effectiveType || null : null,
        slow: conn() ? ["slow-2g", "2g"].includes(conn().effectiveType) : false,
    });
    const [status, setStatus] = useState(read);
    useEffect(() => {
        const update = () => setStatus(read());
        window.addEventListener("online", update);
        window.addEventListener("offline", update);
        const c = conn();
        if (c && c.addEventListener) c.addEventListener("change", update);
        return () => {
            window.removeEventListener("online", update);
            window.removeEventListener("offline", update);
            if (c && c.removeEventListener) c.removeEventListener("change", update);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return status;
};
